module.exports = __webpack_public_path__ + "74567a0773d81d967492ea7e73280fd1.svg";